"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.REDUCER_KEY = exports.mkPlaidAggregationInfo = exports.mkFinicityAggregationInfo = exports.AccountDiscoveryFailure = exports.ACCOUNT_ACTION_IGNORE = exports.ACCOUNT_ACTION_ADD = exports.mkAccountAction = exports.mkAccountDiscoveryStatus = exports.mkAccountDiscoveryAggregatorStatus = exports.mkInstitutionLoginUpserterStore = exports.mkInstitutionLoginUpserterData = exports.mkAccountDiscoveryData = exports.mkActiveDiscoveredAccount = exports.mkDiscoveredAccount = exports.mkAccountDiscoveryDialogProps = exports.DIALOG_TYPE_ACCOUNTS_DISCOVERY = void 0;
const immutable_1 = require("immutable");
const es6_error_1 = __importDefault(require("es6-error"));
const accounts_1 = require("companion-app-components/flux/accounts");
exports.DIALOG_TYPE_ACCOUNTS_DISCOVERY = 'DIALOG_TYPE_ACCOUNTS_DISCOVERY';
exports.mkAccountDiscoveryDialogProps = (0, immutable_1.Record)({
    mode: 'ADD-FI',
    initiator: undefined,
    institutionLogin: undefined,
    mfaChallenge: undefined,
    aggAction: undefined,
    afterCloseAction: undefined,
    onClose: undefined,
});
exports.mkDiscoveredAccount = (0, immutable_1.Record)({
    shadowAccountId: null,
    id: null,
    cpId: null,
    cpLoginId: null,
    channel: null,
    type: null,
    subType: null,
    name: null,
    number: null,
    maskedNumber: null,
    balance: null,
    balanceAt: null,
    currency: null,
});
exports.mkActiveDiscoveredAccount = (0, immutable_1.Record)({
    account: accounts_1.accountsTypes.mkAccount('UNKNOWN'),
    discoveredAccount: (0, exports.mkDiscoveredAccount)(),
});
exports.mkAccountDiscoveryData = (0, immutable_1.Record)({
    institutionLoginId: null,
    credentialsBlob: null,
    status: null,
    activeAccounts: null,
    deadAccounts: null,
    newAccounts: null,
    unconnectedAccounts: null,
});
exports.mkInstitutionLoginUpserterData = (0, immutable_1.Record)({
    institution: undefined,
    channel: undefined,
    institutionLogin: undefined,
    institutionLoginIdBeingMigrated: undefined,
    mfaChallenge: undefined,
    partnerAuthUris: undefined,
    publicToken: undefined,
    accountDiscoveryData: undefined,
    updateStrategy: 'UPDATE',
    isAuthenticationDone: false,
    isAccountUpsertingDone: false,
    isAccountRefreshingDone: false,
    isPolling: false,
    isSubmitting: false,
    error: undefined,
});
exports.mkInstitutionLoginUpserterStore = (0, immutable_1.Record)({
    upserterData: (0, immutable_1.Map)(),
});
exports.mkAccountDiscoveryAggregatorStatus = (0, immutable_1.Record)({
    isProcessing: false,
    aggStatus: 'unknown',
    cpAggStatusCode: undefined,
    cpAggStatusDetail: undefined,
    userInstructions: undefined,
});
exports.mkAccountDiscoveryStatus = (0, immutable_1.Record)({
    institutionLoginId: null,
    isProcessing: false,
    status: '',
    aggregators: (0, immutable_1.List)(),
});
exports.mkAccountAction = (0, immutable_1.Record)({
    id: '0',
    type: 'LINK_TO',
    menuItemLabel: 'Link to',
    selectedItemLabel: 'Link',
    accountToLinkTo: null,
});
exports.ACCOUNT_ACTION_ADD = (0, exports.mkAccountAction)({
    id: 'ADD',
    type: 'ADD_ACCOUNT',
    menuItemLabel: 'Add',
    selectedItemLabel: 'Add',
});
exports.ACCOUNT_ACTION_IGNORE = (0, exports.mkAccountAction)({
    id: 'IGNORE',
    type: 'IGNORE',
    menuItemLabel: 'Ignore',
    selectedItemLabel: 'Ignore',
});
// ================================================================================================
// Account Discovery Error Types
// ================================================================================================
class AccountDiscoveryFailure extends es6_error_1.default {
    constructor(message, aggStatus, aggStatusCode) {
        super(message);
        this.aggStatus = aggStatus;
        this.aggStatusCode = aggStatusCode;
    }
}
exports.AccountDiscoveryFailure = AccountDiscoveryFailure;
exports.mkFinicityAggregationInfo = (0, immutable_1.Record)({
    type: 'FINICITY',
    connectUrl: undefined,
    pollingRef: undefined,
});
exports.mkPlaidAggregationInfo = (0, immutable_1.Record)({
    type: 'PLAID',
    linkToken: null,
});
exports.REDUCER_KEY = 'upsertInstitutionLoginStore';
